import React from 'react';
import FundBanner from './FundBanner';
import FundAustraliaDetails from './FundAustraliaDetails';

const FundAustralia = () => {
    return (
        <div>
            <FundBanner/>
            <FundAustraliaDetails/>
        </div>
    );
};

export default FundAustralia;